import React from "react";
import { useDispatch } from "react-redux";
import { Avatar, Popover } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { userSignOut } from "appRedux/actions/Auth";
import { getUserName } from "../../util/profile";

const UserProfile = () => {
  const dispatch = useDispatch();
  const userMenuOptions = (
    <ul className="gx-user-popover">
      <li>
        <a href="/change-password">
          Şifremi Değiştir
        </a>
      </li>
      <li>
        <a onClick={() => dispatch(userSignOut())}>
          Çıkış Yap
        </a>
      </li>
    </ul>
  );

  return (
    <div className="gx-flex-row gx-align-items-center gx-mb-4 gx-avatar-row">
      <Popover
        placement="bottomRight"
        content={userMenuOptions}
        trigger="click"
      >
        <Avatar
          style={{ backgroundColor: "#002447" }}
          icon={<UserOutlined />}
          className="gx-size-40 gx-pointer gx-mr-3"
          alt=""
        />
        <span className="gx-avatar-name">
          {getUserName()}
          <i className="icon icon-chevron-down gx-fs-xxs gx-ml-2" />
        </span>
      </Popover>
    </div>
  );
};

export default UserProfile;
